import React from 'react';
import { IReviewDataRow, IReviewNote } from 'interfaces/review/IReviewDataRow';
import { ICellRendererParams } from '@trackman/baseball-shared-components';
import NoteCell from '../CellComponents/NoteCell/NoteCell';

const noteRenderer = (data: ICellRendererParams<IReviewNote, IReviewDataRow>): JSX.Element => {
  return (
    <NoteCell data={data.value} onResolvedChanged={(newValue: IReviewNote) => data.row.updateData(newValue, data.columnKey, data.row.id)} />
  );
};

export default noteRenderer;
